import React, { Component } from 'react';
import BankDepositList from './BankDepositList';
import BankDepositSave from './BankDepositSave';
import WithRouter from 'custom/withRouter';

class BankDepositPage extends Component {
  constructor(props, context) {
    super(props, context);
  }

  callListView = () => {
    this.props.navigate("/admin/bankdeposits");
  }

  callSaveView = () => {
    this.props.navigate("/admin/bankdeposits/add");
  }

  render() {
    const p = this.props;
    const bankDepositId = p.params.id;
    const isEditing = bankDepositId || p.location.pathname === "/admin/bankdeposits/add";

    return (
      <div>
        {
          isEditing ?
            <BankDepositSave name="BankDepositSave" params={p.params}
              callListView={this.callListView} title="Add New Bank Deposit" />
            : <BankDepositList onTouchTap={this.callSaveView} title="List of Bank Deposits" />
        }
      </div>
    );
  }
}

export default WithRouter(BankDepositPage);
